import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { getCookie } from "@/utils/cookies";
import store from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadDecHub',
  setup(__props) {

const handleDownload = () => {
  store.dispatch("download/downloadDecHub");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: "javascript:;",
    onClick: handleDownload,
    class: "download"
  }, _toDisplayString(_ctx.$t("header.DECDow")), 1))
}
}

})